import SolrService from '@/common/solr.service';

export default {
  name: 'SpeakerModalContent',
  data() {
    return {
      isLoading: true,
      speakerData: [],
      organizers: [],
    };
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
    getFormattedDate: {
      type: Function,
      required: true,
    },
    getFormattedDateTime: {
      type: Function,
      required: true,
    },
    getFormattedOrganizerSpace: {
      type: Function,
      required: true,
    },
    showDetail: {
      type: Function,
      required: true,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    getAvatarImg: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    const response = await SolrService.getSpeakerLectureData(this.entry.id);
    this.speakerData = response.data.response.docs;
    this.speakerData.forEach((item) => {
      this.organizers.push({name: item.fp_organizer_text, place: this.getFormattedOrganizerSpace(item)});
    });
    this.isLoading = false;
  },
  methods: {
    showProgramDetail(program, speaker) {
      this.$emit('showProgramDetail', [program, speaker]);
    },
  },
  computed: {
    sortedProgram() {
      return this.speakerData.sort((a, b) => new Date(a.fp_starttime) - new Date(b.fp_starttime));
    },
    personData() {
      if (this.entry.fp_persons && this.entry.fp_persons.length > 0) {
        return JSON.parse(this.entry.fp_persons[0]);
      }
      return null;
    },
    socialMedias() {
      if (this.personData && this.personData.socialMedia && this.personData.socialMedia.length) {
        return this.personData.socialMedia.filter(sm => sm.channel !== null && sm.url !== null);
      }
      return [];
    },
  }
};
